//  ----------      START   IMPORT  BLOCK       ----------
import { useState } from "react";
import BaseLayout from "../../General/LandingPage/BaseLayout/BaseLayout";
//  Widgets
import { Container, ProgressBar, Card, Button, Badge } from "react-bootstrap";
import StepWelcome from "./Steps/StepWelcome";
import StepBasics from "../ProfileOnboarding/Steps/StepBasics";
import StepGeneralHealth from "../ProfileOnboarding/Steps/StepGeneralHealth";
import StepSubstanceUse from "../ProfileOnboarding/Steps/StepSubstanceUse";

import { ProToPatientValidator } from "./ProToPatientValidator";
import ProToPatientService from "../../../../API/Services/UserProToPatient";
//  Context
import { useLanguage } from "../../../../API/Context/LanguageContext";
//  Config
import { VocabProToPatient as Vocab } from "../../../../ConfigFiles/multilingual/VocabProToPatient"; 
import { VocabButtons } from "../../../../ConfigFiles/multilingual/VocabButtons";
//  ----------      END   IMPORT  BLOCK       ----------

const ProToPatient = () => {
    const { lan } = useLanguage();
    const totalSteps = 3;
    const [step, setStep] = useState(0);

    

    //  Memory for skills stores { [id]: { name, category } }
    const [uiMetadata, setUiMetadata] = useState({
        skills: {},
        specialties: {},
        subspecialties: {},
        states: {},

    });

    const updateMetadata = (category, newMeta) => {
        setUiMetadata(prev => ({
            ...prev,
            [category]: { ...(prev[category] || {}), ...newMeta }
        }));
    };

    const [formData, setFormData] = useState({
        sex: 0, height: 170, weight: 70, marital_status: 0, scholarship: 0, religion: 0, occupation: "", birthplace: "",
        diet: { meals_per_day: 3, water_liters: 2, frequency_junk_food: 0, is_special_diet: false, diet_type: 0},
        fitness: { level: 0, frequency_per_week: 0 },
        substances: { has_history: false, substances_detail: []},
        sexual_health: { status: false, partners_range: 0, protection: 0 }
    });

    const isStepValid = ProToPatientValidator[step](formData);

    const updateFormData = (newData) => setFormData(prev => ({ ...prev, ...newData }));

    const handleSubmit = async () => {
    try {
        const reply = await ProToPatientService.createProfileOnboarding(formData);
        console.log("Success:", reply);
    } catch (err) {
        // handle error
    }
};

    return (
        <BaseLayout>
            <Container className="py-5 onboarding-container">
                {/* --- HEADER SECTION --- */}
                <div className="text-center mb-4">
                    <h2 className="fw-bold text-primary">{Vocab.pro_onboarding_title[lan]}</h2>
                    <p className="text-muted mb-2">{Vocab.pro_onboarding_message[lan]}</p>
                    
                    <div className="d-flex align-items-center justify-content-center gap-3">
                        <ProgressBar 
                            now={(step / totalSteps) * 100} 
                            style={{ height: "10px", width: "100%", maxWidth: "400px" }} 
                            className="rounded-pill shadow-sm"
                        />
                        <Badge bg="primary" className="rounded-pill px-3 py-2">
                            {step} / {totalSteps}
                        </Badge>
                    </div>
                </div>

                <Card className="shadow-lg border-0 rounded-4">
                    <Card.Body className="p-4 p-md-5">
                        {/* Define your logic for the Pro steps here */}
                        {step === 0 && <StepWelcome />}
                        {step === 1 && <StepBasics data={formData} update={updateFormData} no_core={true} isImmutable={false}/>}
                        {step === 2 && <StepSubstanceUse data={formData} update={updateFormData}/>}
                        {step === 3 && <StepGeneralHealth data={formData} update={updateFormData}/>}
                        <div className="d-flex justify-content-between mt-5 pt-3 border-top">
                            <Button 
                                variant="outline-secondary" 
                                size="lg" 
                                onClick={() => setStep(s => s - 1)} 
                                disabled={step === 0}
                            >
                                {step === 0 ? "---" : VocabButtons.back[lan]}
                            </Button>
                            
                            <Button 
                                variant="primary" 
                                size="lg" 
                                disabled={!isStepValid} //
                                onClick={() => step === totalSteps ? handleSubmit() : setStep(s => s + 1)}
                            >
                                {step === 0 ? VocabButtons.start[lan] : step === totalSteps ? VocabButtons.submit[lan] : VocabButtons.next[lan]}
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </BaseLayout>
    );
};

export default ProToPatient;